module.exports = __webpack_public_path__ + "static/media/screenshot42.606329aa.png";